import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  IonFab,
  IonFabButton,
  IonFabList,
  IonToast,
} from '@ionic/angular/standalone';

@Component({
  selector: 'cmn-fab-contact',
  templateUrl: './fab-contact.component.html',
  styleUrls: ['./fab-contact.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FontAwesomeModule, IonFabButton, IonFab, IonFabList, IonToast],
})
export class FabContactComponent {
  mailLink = input.required<string>();
  instagramDirectMessageLink = input.required<string>();
  whatsAppLink = input.required<string>();
  facebookMessengerLink = input.required<string>();
  isToastOpen = true;

  dismissToast(): void {
    this.isToastOpen = false;
  }

  shadowBottom(): void {
    // SUPER HACK pour modifier une position dans le shadow dom
    // @ts-ignore
    const element: Element = document
      .querySelector('ion-toast')
      ?.shadowRoot?.querySelector('div.toast-wrapper');
    if (element) {
      element.setAttribute('style', 'bottom: 140px;');
    }
  }
}
